import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { ModalTerms } from "../../components/ModalTerms";
import { useOrder } from "../../hooks/useOrder";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import { cnpj, cpf } from "cpf-cnpj-validator";

import { useAppConfig } from "../../hooks/useAppConfig";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import "./index.css";
import { Slide, toast } from "react-toastify";
import api from "../../services/api";
import {
  cepNoMask,
  cpfCnpjNoMask,
  dateBRToDateISO,
  datetimeToDateBR,
  rtcToText,
  telephoneNoMask,
} from "../../functions/mask";
import { usePluginspace } from "../../hooks/usePluginspace";
import { CustomerType } from "../../contexts/OrderContext";
import { useFoodConfig } from "../../hooks/useFood";
import { ModalConfirmWpp } from "../../components/ModalConfirmWpp";

type configField = {
  visible: boolean;
  mandatory: boolean;
  name: string;
  fieldName: string;
};

export function Customer() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const {
    getCustomer,
    setCustomer,
    getType,
    getOrderAddress,
    synchronizeContextToStorage,
    getCustomerAdress,
    changeCustomerDocument,
  } = useOrder();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const orderContext = useOrder();

  const [useWpp, setUseWpp] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cpfOrCnpj, setCpfOrCnpj] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [gender, setGender] = useState("masculino");
  const [telephone, setTelephone] = useState("");
  const [cep, setCep] = useState("");
  const [address, setAddress] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [ibge, setIbge] = useState("");
  const [typePluginSpace, setTypePluginSpace] = useState("");

  const [openTerms, setOpenTerms] = useState(false);

  const [alarmName, setAlarmName] = useState(false);
  const [alarmEmail, setAlarmEmail] = useState(false);
  const [alarmCpf, setAlarmCpf] = useState(false);
  const [alarmBirthdate, setAlarmBirthdate] = useState(false);
  const [alarmTelephone, setAlarmTelephone] = useState(false);
  const [alarmCep, setAlarmCep] = useState(false);
  const [alarmAddress, setAlarmAddress] = useState(false);
  const [alarmDistrict, setAlarmDistrict] = useState(false);
  const [alarmCity, setAlarmCity] = useState(false);
  const [alarmState, setAlarmState] = useState(false);
  const [alarmNumber, setAlarmNumber] = useState(false);
  const { customerName, customerPhone } = useFoodConfig();
  const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
  const [maskTelephone, setMaskTelephone] = useState("(99) 9999-9999");

  const [term, setTerm] = useState("");

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);

  const [acceptTerm, setAcceptTerm] = useState(false);
  const [type, setType] = useState("");

  const [hideMenu, setHideMenu] = useState(false);

  const [selectedDoc, setSelectedDoc] = useState("cpf");
  const [inscEstadual, setInscEstadual] = useState("");

  //Tem FieldConfig? (Se não tiver continua igual, se tiver montar de acordo com as configurações)
  const [haveFieldConfig, setHaveFieldConfig] = useState(false);
  const [fieldsConfig, setFieldsConfig] = useState<configField[]>([]);
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [documentBlocked, setDocumentBlocked] = useState("");
  const [wppAvaiable, setWppAvaiable] = useState(false);

  const [openConfirmWpp, setOpenConfirmWpp] = useState(false);
  const [codeWpp, setCodeWpp] = useState("");
  const [confirmWpp, setConfirmWpp] = useState(false);

  const [customerId, setCustomerId] = useState<string | undefined>();
  const [customerValidationRegister, setCustomerValidationRegister] =
    useState(false);
  const [confirmValidationRegister, setConfirmValidationRegister] =
    useState(false);

  useEffect(() => {
    registerAccess("customer");
    getConfig();
  }, []);

  async function loadOrder() {
    await getToken();
    const customer = await getCustomer();

    // if (customer.wppNotification) setUseWpp(customer.wppNotification);
    if (customer.name) {
      setName(customer.name);
    } else if (customerName) {
      setName(customerName);
    }
    if (customer.email) setEmail(customer.email);
    if (customer.cpf) setCpfOrCnpj(customer.cpf);
    if (customer.birthdate) setBirthdate(customer.birthdate);
    if (customer.gender) setGender(customer.gender);
    if (customer.telephone) {
      setTelephone(customer.telephone);
    } else if (customerPhone) {
      setTelephone(customerPhone);
    }
    if (customer.cep) setCep(customer.cep);
    if (customer.address) setAddress(customer.address);
    if (customer.district) setDistrict(customer.district);
    if (customer.city) setCity(customer.city);
    if (customer.state) setState(customer.state);
    if (customer.number) setNumber(customer.number);
    if (customer.complement) setComplement(customer.complement);
    if (customer.ibge) setIbge(customer.ibge);
    if (customer.inscEstadual) setInscEstadual(customer.inscEstadual);
    if (customer.id) setCustomerId(customer.id.toString());
    if (customer.validateRegister)
      setCustomerValidationRegister(customer.validateRegister);

    const newType = await getType();
    setType(newType);
    const typePlugin = await getThisPluginspace();

    setTypePluginSpace(typePlugin!.type);
  }

  async function verifyWppToOpen() {
    setLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);

    try {
      const response = await api.get(
        `/api/zapnis-web/sendCodeConfirm/55${telephoneNoMask(telephone)}@us`,
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
          signal: controller.signal,
        }
      );

      clearTimeout(timeoutId);
      setLoading(false);
      if (response.data.code) {
        setCodeWpp(window.atob(response.data.code));
        setOpenConfirmWpp(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Falha ao enviar código de confirmação para o seu celular",
        });
      }
    } catch (error) {
      setUseWpp(false);
      toast.error("Falha ao enviar código de confirmação para o seu celular", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
      setLoading(false);
    }
  }

  async function verifyStatusWhatsapp() {
    try {
      await api
        .post(
          `/api/pluginconfig/filter`,
          {
            plugintemplateId: 234,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.data[0].content.able === "1") {
            setWppAvaiable(true);
            return;
          } else setWppAvaiable(false);
        })
        .catch((err) => {
          console.log(err);
          setWppAvaiable(false);
        });
    } catch (error) {
      console.log(error);
      setWppAvaiable(false);
    }
  }

  async function getOrderAddressNew() {
    const typeStorage = await getType();
    const orderAddressStorage = await getOrderAddress();
    if (typeStorage === "delivery") {
      if (orderAddressStorage.city !== undefined)
        setCity(orderAddressStorage.city);
      if (orderAddressStorage.address !== undefined)
        setAddress(orderAddressStorage.address);
      if (orderAddressStorage.district !== undefined)
        setDistrict(orderAddressStorage.district);
      if (orderAddressStorage.cep !== undefined)
        setCep(orderAddressStorage.cep);
      if (orderAddressStorage.number !== undefined)
        setNumber(orderAddressStorage.number);
      if (orderAddressStorage.state !== undefined)
        setState(orderAddressStorage.state);
      if (orderAddressStorage.telephone !== undefined) {
        if (orderAddressStorage.telephone.length >= 11) {
          setMaskTelephone("(99) 99999-9999");
        } else {
          setMaskTelephone("(99) 9999-9999");
        }
        setTelephone(orderAddressStorage.telephone);
      }
    } else {
      const endereco = await getCustomerAdress();
      await findCep(endereco.cep, true);
      setCep(endereco.cep);
    }
  }

  async function getFieldConfig() {
    const fieldConfig = await api
      .get(`/api/fieldconfig`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        return response.data.data[0];
      })
      .catch((err) => {
        console.log(err.data);
        return err;
      });

    setHaveFieldConfig(fieldConfig ? true : false);

    if (fieldConfig) {
      const data: configField[] = [];
      const regexPattern = new RegExp("true");

      Object.entries(fieldConfig.content).map((fieldConfig: any) => {
        data.push({
          visible: regexPattern.test(fieldConfig[1].visible),
          name: fieldConfig[0],
          fieldName: fieldConfig[1].name,
          mandatory: regexPattern.test(fieldConfig[1].mandatory),
        });
      });

      setFieldsConfig(data);
    }
  }

  async function loadCustomer() {
    const customerDocumento = await orderContext.getCustomerDocument();

    if (customerDocumento) {
      setCpfOrCnpj(customerDocumento!);
      await findCustomer2(customerDocumento);
    }
  }

  async function getConfig() {
    setLoading(true);
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    await verifyStatusWhatsapp();
    await synchronizeContextToStorage();
    await getOrderAddressNew();
    await getFieldConfig();
    await loadOrder();
    await getTerms();
    await loadCustomer();
    setLoading(false);
  }

  const updateCartWithCustomer = async () => {
    if (orderContext.shouldUpdadeCart) {
      const link = `${window.location.origin}/${
        window.location.pathname.split("/")[1]
      }/cart`;

      if (orderContext.guidCart) {
        //update
        /*
				1- Recuperar o carrinho pelo guidCart
				2- Atualizar Produtos, endereços Type e Freight
				*/

        let customerCart: any = {};

        const tokenAccess = await getToken();
        const newOrder = await orderContext.getOrder();

        setLoading(true);

        await api
          .get(`/api/customerCart/guid/${orderContext.guidCart}`, {
            headers: {
              Authorization: `Bearer ${tokenAccess}`,
            },
          })
          .then(async (response) => {
            customerCart = response.data.data[0];
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
        const objCustomerCart = {
          customerName: name,
          cpfCustomer: cpfCnpjNoMask(cpfOrCnpj),
          phoneCustomer: telephoneNoMask(telephone),
          jsonCart: customerCart.jsonCart,
          locationId: customerCart.locationId,
          guid: customerCart.guidCart,
        };

        objCustomerCart.jsonCart.products = newOrder!.products;

        await api
          .put(`/api/customerCart/${customerCart.id}`, objCustomerCart, {
            headers: {
              Authorization: `Bearer ${tokenAccess}`,
            },
          })
          .then(async (response) => {})
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });

        setLoading(false);

        return;
      }

      return;
    }
  };

  async function getTermsTotvs() {
    return await api
      .get(`/api/letter-consent`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const totvsRes = response.data;
        if (totvsRes && totvsRes.data && totvsRes.data.body) {
          setTerm(rtcToText(totvsRes.data.body));
          return true;
        } else {
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
  }

  async function getTerms() {
    const hasTotvsTerms = await getTermsTotvs();
    if (!hasTotvsTerms) {
      await api
        .post(
          `/api/consent/filter`,
          {
            active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setTerm(response.data.data[0].content);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function verify(verify: boolean, valor: string) {
    /* 
			Regra : 
			Se é obrigatoria verifica se o valor é diferente de vazio || ""
			caso n for obrigatorio retorne true
		*/

    if (verify) {
      //verifica se o campo foi escrito ou não
      return valor !== "" ? true : false;
    }
    return true;
  }

  function shouldChangeOrderAddressCEP(customer: any) {
    if (
      typePluginSpace === "fashion" &&
      customer.shouldChangeAdressResultFashion
    ) {
      localStorage.setItem(
        "shouldChangeAddressFashion",
        customer.shouldChangeAdressResultFashion
      );
    }
  }

  async function continueOrder() {
    if (
      documentBlocked === cpfCnpjNoMask(cpfOrCnpj) &&
      cpfOrCnpj !== "" &&
      !cpfOrCnpj.includes("_")
    ) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: `Este usuário está bloqueado`,
      });
      clearAllCustomer();
      return;
    }

    //Verifica se é do tipo food
    const isFood = typePluginSpace === "food" ? true : false;

    //Possui Configurações dos Campos e não precisa do endereço pq é FOOD
    if (haveFieldConfig && isFood) {
      const emailField = fieldsConfig.find(
        (field: configField) => field.name === "email"
      );
      const birthField = fieldsConfig.find(
        (field: configField) => field.name === "dataNascimento"
      );
      const genderField = fieldsConfig.find(
        (field: configField) => field.name === "genero"
      );
      const phoneField = fieldsConfig.find(
        (field: configField) => field.name === "telefone"
      );

      if (
        cpf &&
        name &&
        verify(emailField!.mandatory, email) &&
        verify(genderField!.mandatory, gender) &&
        verify(birthField!.mandatory, birthdate) &&
        verify(phoneField!.mandatory, telephone)
      ) {
        if (phoneField!.mandatory) {
          if (telephone.includes("_")) {
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: "Telefone inválido",
            });
            setTelephone("");
            return;
          }
        }

        if (
          name.split(" ").length < 2 ||
          !name.split(" ")[1] ||
          name.split(" ")[1] === ""
        ) {
          Swal.fire({
            icon: "warning",
            title: "Nome inválido!",
            text: "Informe seu sobrenome",
          });
          return;
        }

        if (cpfOrCnpj.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
          setCpfOrCnpj("");
          return;
        }

        if (emailField!.mandatory) {
          if (!email.includes("@")) {
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: "E-mail inválido",
            });
            setEmail("");
            return;
          }
        }

        if (cpfOrCnpj.length <= 14 && !cpf.isValid(cpf.strip(cpfOrCnpj))) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
        } else if (cpfOrCnpj.length > 14 && !cnpj.isValid(cpfOrCnpj)) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CNPJ inválido",
          });
        } else {
          setLoading(true);
          let customerToSend = {};
          const orderAddressStorage = await getOrderAddress();
          if (type === "delivery") {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
                {
                  typePhone: "secondary",
                  numberPhone:
                    orderAddressStorage.telephone !== undefined
                      ? telephoneNoMask(orderAddressStorage.telephone)
                      : orderAddressStorage.telephone,
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              birthdate: birthdate ? dateBRToDateISO(birthdate) : null,
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
                {
                  zipCode: orderAddressStorage.cep
                    ? cepNoMask(orderAddressStorage.cep)
                    : orderAddressStorage.cep,
                  street: orderAddressStorage.address,
                  number: orderAddressStorage.number,
                  district: orderAddressStorage.district,
                  city: orderAddressStorage.city,
                  state: orderAddressStorage.state,
                  extra: orderAddressStorage.complement,
                  reference: "",
                  typeAddress: "delivery",
                  ibge: orderAddressStorage.ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          } else {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              birthDate: birthdate ? dateBRToDateISO(birthdate) : null,
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          }

          await api
            .post(`/api/customer`, customerToSend, {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            })
            .then(async (response) => {
              setLoading(false);
              if (response.data.success === true) {
                let customer: CustomerType = {
                  id: response.data.dados.id
                    ? response.data.dados.id
                    : response.data.dados.dados.id,
                  name,
                  email,
                  cpf: cpfOrCnpj,
                  birthdate,
                  wppNotification: useWpp,
                  acceptTermDate: response.data.dados.lgpdDataAceiteCarta
                    ? response.data.dados.lgpdDataAceiteCarta
                    : response.data.dados.dados.lgpdDataAceiteCarta,
                  gender,
                  telephone,
                  cep,
                  address,
                  district,
                  city,
                  state,
                  number,
                  complement,
                  ibge,
                  inscEstadual,
                };
                if (response.data.dados && response.data.dados.customerId) {
                  customer.customerWinthor = response.data.dados.customerId;
                }
                setCustomer(customer);
                shouldChangeOrderAddressCEP(response.data.dados);
                await updateCartWithCustomer();
                navigate(`/${pluginspace_id}/order`);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: "Falha ao cadastrar cliente",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
              console.log(err);
            });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Verifique se preencheu todos os campos",
        });
      }
    } //Não Possui Configurações do Campo e  é do tipo FOOD
    else if (isFood) {
      if (cpf && email && gender && birthdate && telephone && name) {
        if (telephone.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Telefone inválido",
          });
          setTelephone("");
          return;
        }

        // Verifica se possui sobrenome
        if (
          name.split(" ").length < 2 ||
          !name.split(" ")[1] ||
          name.split(" ")[1] === ""
        ) {
          Swal.fire({
            icon: "warning",
            title: "Nome inválido!",
            text: "Informe seu sobrenome",
          });
          return;
        }

        if (cpfOrCnpj.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
          setCpfOrCnpj("");
          return;
        }

        if (!email.includes("@")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "E-mail inválido",
          });
          setEmail("");
          return;
        }

        if (cpfOrCnpj.length <= 14 && !cpf.isValid(cpf.strip(cpfOrCnpj))) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
        } else if (cpfOrCnpj.length > 14 && !cnpj.isValid(cpfOrCnpj)) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CNPJ inválido",
          });
        } else {
          setLoading(true);
          let customerToSend = {};
          const orderAddressStorage = await getOrderAddress();
          if (type === "delivery") {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
                {
                  typePhone: "secondary",
                  numberPhone:
                    orderAddressStorage.telephone !== undefined
                      ? telephoneNoMask(orderAddressStorage.telephone)
                      : orderAddressStorage.telephone,
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              birthDate: dateBRToDateISO(birthdate),
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
                {
                  zipCode: orderAddressStorage.cep
                    ? cepNoMask(orderAddressStorage.cep)
                    : orderAddressStorage.cep,
                  street: orderAddressStorage.address,
                  number: orderAddressStorage.number,
                  district: orderAddressStorage.district,
                  city: orderAddressStorage.city,
                  state: orderAddressStorage.state,
                  extra: orderAddressStorage.complement,
                  reference: "",
                  typeAddress: "delivery",
                  ibge: orderAddressStorage.ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          } else {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              birthDate: dateBRToDateISO(birthdate),
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          }
          await api
            .post(`/api/customer`, customerToSend, {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            })
            .then(async (response) => {
              setLoading(false);
              if (response.data.success === true) {
                let customer: CustomerType = {
                  id: response.data.dados.id
                    ? response.data.dados.id
                    : response.data.dados.dados.id,
                  name,
                  email,
                  cpf: cpfOrCnpj,
                  birthdate,
                  wppNotification: useWpp,
                  acceptTermDate: response.data.dados.lgpdDataAceiteCarta
                    ? response.data.dados.lgpdDataAceiteCarta
                    : response.data.dados.dados.lgpdDataAceiteCarta,
                  gender,
                  telephone,
                  cep,
                  address,
                  district,
                  city,
                  state,
                  number,
                  complement,
                  ibge,
                  inscEstadual,
                };
                if (response.data.dados && response.data.dados.customerId) {
                  customer.customerWinthor = response.data.dados.customerId;
                }
                setCustomer(customer);
                shouldChangeOrderAddressCEP(response.data.dados);
                await updateCartWithCustomer();
                navigate(`/${pluginspace_id}/order`);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: "Falha ao cadastrar cliente",
                });
              }
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
            });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Verifique se preencheu todos os campos",
        });
      }
    } else if (haveFieldConfig) {
      const emailField = fieldsConfig.find(
        (field: configField) => field.name === "email"
      );
      const birthField = fieldsConfig.find(
        (field: configField) => field.name === "dataNascimento"
      );
      const genderField = fieldsConfig.find(
        (field: configField) => field.name === "genero"
      );
      const phoneField = fieldsConfig.find(
        (field: configField) => field.name === "telefone"
      );

      if (
        cpf &&
        name &&
        verify(emailField!.mandatory, email) &&
        verify(genderField!.mandatory, gender) &&
        verify(birthField!.mandatory, birthdate) &&
        verify(phoneField!.mandatory, telephone) &&
        cep &&
        address &&
        district &&
        city &&
        state &&
        number
      ) {
        if (phoneField!.mandatory) {
          if (telephone.includes("_")) {
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: "Telefone inválido",
            });
            setTelephone("");
            return;
          }
        }

        if (cep.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CEP inválido",
          });
          setCep("");
          return;
        }

        if (
          name.split(" ").length < 2 ||
          !name.split(" ")[1] ||
          name.split(" ")[1] === ""
        ) {
          Swal.fire({
            icon: "warning",
            title: "Nome inválido!",
            text: "Informe seu sobrenome",
          });
          return;
        }

        if (cpfOrCnpj.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
          setCpfOrCnpj("");
          return;
        }

        if (emailField!.mandatory) {
          if (!email.includes("@")) {
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: "E-mail inválido",
            });
            setEmail("");
            return;
          }
        }

        if (cpfOrCnpj.length <= 14 && !cpf.isValid(cpf.strip(cpfOrCnpj))) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
        } else if (cpfOrCnpj.length > 14 && !cnpj.isValid(cpfOrCnpj)) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CNPJ inválido",
          });
        } else {
          setLoading(true);
          let customerToSend = {};
          const orderAddressStorage = await getOrderAddress();
          if (type === "delivery") {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
                {
                  typePhone: "secondary",
                  numberPhone:
                    orderAddressStorage.telephone !== undefined
                      ? telephoneNoMask(orderAddressStorage.telephone)
                      : orderAddressStorage.telephone,
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              birthDate: dateBRToDateISO(birthdate),
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
                {
                  zipCode: orderAddressStorage.cep
                    ? cepNoMask(orderAddressStorage.cep)
                    : orderAddressStorage.cep,
                  street: orderAddressStorage.address,
                  number: orderAddressStorage.number,
                  district: orderAddressStorage.district,
                  city: orderAddressStorage.city,
                  state: orderAddressStorage.state,
                  extra: orderAddressStorage.complement,
                  reference: "",
                  typeAddress: "delivery",
                  ibge: orderAddressStorage.ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          } else {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              birthDate: dateBRToDateISO(birthdate),
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          }
          await api
            .post(`/api/customer`, customerToSend, {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            })
            .then(async (response) => {
              setLoading(false);
              if (response.data.success === true) {
                let customer: CustomerType = {
                  id: response.data.dados.id
                    ? response.data.dados.id
                    : response.data.dados.dados.id,
                  name,
                  email,
                  cpf: cpfOrCnpj,
                  birthdate,
                  wppNotification: useWpp,
                  acceptTermDate: response.data.dados.lgpdDataAceiteCarta
                    ? response.data.dados.lgpdDataAceiteCarta
                    : response.data.dados.dados.lgpdDataAceiteCarta,
                  gender,
                  telephone,
                  cep,
                  address,
                  district,
                  city,
                  state,
                  number,
                  complement,
                  ibge,
                  inscEstadual,
                };
                if (response.data.dados && response.data.dados.customerId) {
                  customer.customerWinthor = response.data.dados.customerId;
                }
                setCustomer(customer);
                shouldChangeOrderAddressCEP(response.data.dados);
                await updateCartWithCustomer();
                navigate(`/${pluginspace_id}/order`);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: "Falha ao cadastrar cliente",
                });
              }
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
            });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Verifique se preencheu todos os campos",
        });
      }
    }
    // Não Possui Configurações do Campo e Não é do Tipo FOOD e Retirada
    else {
      if (
        name &&
        email &&
        cpf &&
        birthdate &&
        telephone &&
        cep &&
        address &&
        district &&
        city &&
        state &&
        number &&
        gender
      ) {
        if (telephone.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Telefone inválido",
          });
          setTelephone("");
          return;
        }

        if (cep.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CEP inválido",
          });
          setCep("");
          return;
        }

        // Verifica se possui sobrenome
        if (
          name.split(" ").length < 2 ||
          !name.split(" ")[1] ||
          name.split(" ")[1] === ""
        ) {
          Swal.fire({
            icon: "warning",
            title: "Nome inválido!",
            text: "Informe seu sobrenome",
          });
          return;
        }

        if (cpfOrCnpj.includes("_")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
          setCpfOrCnpj("");
          return;
        }

        if (!email.includes("@")) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "E-mail inválido",
          });
          setEmail("");
          return;
        }

        const cepOk = await findCep(cep);
        if (!cepOk) return;

        if (cpfOrCnpj.length <= 14 && !cpf.isValid(cpf.strip(cpfOrCnpj))) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CPF inválido",
          });
        } else if (cpfOrCnpj.length > 14 && !cnpj.isValid(cpfOrCnpj)) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "CNPJ inválido",
          });
        } else {
          setLoading(true);
          let customerToSend = {};
          const orderAddressStorage = await getOrderAddress();
          if (type === "delivery") {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
                {
                  typePhone: "secondary",
                  numberPhone:
                    orderAddressStorage.telephone !== undefined
                      ? telephoneNoMask(orderAddressStorage.telephone)
                      : orderAddressStorage.telephone,
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              birthDate: dateBRToDateISO(birthdate),
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
                {
                  zipCode: orderAddressStorage.cep
                    ? cepNoMask(orderAddressStorage.cep)
                    : orderAddressStorage.cep,
                  street: orderAddressStorage.address,
                  number: orderAddressStorage.number,
                  district: orderAddressStorage.district,
                  city: orderAddressStorage.city,
                  state: orderAddressStorage.state,
                  extra: orderAddressStorage.complement,
                  reference: "",
                  typeAddress: "delivery",
                  ibge: orderAddressStorage.ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          } else {
            customerToSend = {
              name: name,
              email: email,
              phones: [
                {
                  typePhone: "cell",
                  numberPhone: telephoneNoMask(telephone),
                },
              ],
              doc: cpfCnpjNoMask(cpfOrCnpj),
              cpf: cpfCnpjNoMask(cpfOrCnpj),
              optinWhatsapp: useWpp ? true : false,
              validateRegister: customerValidationRegister,
              birthDate: dateBRToDateISO(birthdate),
              gender: gender,
              lgpdDataAceiteCarta: new Date(),
              password: "",
              inscEstadual,
              addresses: [
                {
                  zipCode: cep ? cepNoMask(cep) : "",
                  street: address,
                  number: number,
                  district: district,
                  city: city,
                  state: state,
                  extra: complement,
                  reference: "",
                  typeAddress: "main",
                  ibge,
                },
              ],
              pluginconfigId: config?.content.pdv.pluginconfigId
                ? config?.content.pdv.pluginconfigId
                : 0,
            };
          }
          await api
            .post(`/api/customer`, customerToSend, {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            })
            .then(async (response) => {
              setLoading(false);
              if (response.data.success === true) {
                let customer: CustomerType = {
                  id: response.data.dados.id
                    ? response.data.dados.id
                    : response.data.dados.dados.id,
                  name,
                  email,
                  cpf: cpfOrCnpj,
                  birthdate,
                  wppNotification: useWpp,
                  validateRegister: customerValidationRegister,
                  acceptTermDate: response.data.dados.lgpdDataAceiteCarta
                    ? response.data.dados.lgpdDataAceiteCarta
                    : response.data.dados.dados.lgpdDataAceiteCarta,
                  gender,
                  telephone,
                  cep,
                  address,
                  district,
                  city,
                  state,
                  number,
                  complement,
                  ibge,
                  inscEstadual,
                };
                if (response.data.dados && response.data.dados.customerId) {
                  customer.customerWinthor = response.data.dados.customerId;
                }
                setCustomer(customer);

                shouldChangeOrderAddressCEP(response.data.dados);
                await updateCartWithCustomer();

                navigate(`/${pluginspace_id}/order`);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: "Falha ao cadastrar cliente",
                });
              }
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
            });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Verifique se preencheu todos os campos",
        });
      }
    }
  }

  function readTerms() {
    setOpenTerms(true);
  }

  function changeTelephone(newPhone: string) {
    const phoneValidated = newPhone.replaceAll("_", "");
    if (phoneValidated.length >= 14 && phoneValidated[13] !== "_") {
      setMaskTelephone("(99) 99999-9999");
    } else {
      setMaskTelephone("(99) 9999-9999");
    }
  }

  async function findCep(cep: string, firstSearch?: boolean) {
    if (cep) {
      return await api
        .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
        .then((response) => {
          if (response.data.erro) {
            setCity("");
            setAddress("");
            setDistrict("");
            setState("");
            Swal.fire({
              icon: "warning",
              title: "CEP inválido!",
              text: "Verifique se o CEP foi digitado corretamente.",
            });
            return false;
          } else {
            if (response.data.ibge !== "") setIbge(response.data.ibge);
            else setIbge("");

            if (response.data.localidade !== "")
              setCity(response.data.localidade);
            else setCity("");

            if (response.data.logradouro !== "")
              setAddress(response.data.logradouro);
            else setAddress("");

            if (response.data.bairro !== "") setDistrict(response.data.bairro);
            else setDistrict("");

            if (response.data.uf !== "") setState(response.data.uf);
            else setState("");

            if (!firstSearch) setNumber("");
            setComplement("");
            return true;
          }
        })
        .catch(() => {
          setCity("");
          setAddress("");
          setDistrict("");
          setState("");
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          return false;
        });
    } else {
      return false;
    }
  }

  async function findCustomer() {
    if (
      cpfOrCnpj === undefined ||
      cpfOrCnpj[0] === "_" ||
      (selectedDoc === "cpf" && !cpf.isValid(cpfOrCnpj)) ||
      (selectedDoc === "cnpj" && !cnpj.isValid(cpfOrCnpj))
    ) {
      setAlarmCpf(true);
    } else {
      setAlarmCpf(false);
    }
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);
    changeCustomerDocument(cpfWithouthMask);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        setLoading(false);
        if (response.data.data.length > 0) {
          const data = response.data.data[0];

          if (
            (data.customerStatus && data.customerStatus === "Bloqueado") ||
            (data.status && data.status === "blocked")
          ) {
            setDocumentBlocked(data.doc);
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: "Seu cadastro está inativo. Entre em contato com a loja.",
            });
            clearAllCustomer();
            return;
          }

          if (data.name) setAlarmName(false);
          else setAlarmName(true);
          setName(data.name);

          if (data.id) setCustomerId(data.id);

          if (data.validateRegister)
            setCustomerValidationRegister(data.validateRegister);

          if (data.email) setAlarmEmail(false);
          else setAlarmEmail(true);
          setEmail(data.email);

          if (data.birthDate) {
            setAlarmBirthdate(false);
            setBirthdate(datetimeToDateBR(data.birthDate));
          } else setAlarmBirthdate(true);

          if (data.gender) {
            setGender(data.gender.toLowerCase());
          } else {
            setGender("masculino");
          }

          if (data.inscEstadual) {
            setInscEstadual(data.inscEstadual);
          }

          if (
            data.customerPhones[data.customerPhones.length - 1].numberPhone
              .length >= 11
          ) {
            setMaskTelephone("(99) 99999-9999");
          } else {
            setMaskTelephone("(99) 9999-9999");
          }

          if (data.customerPhones[data.customerPhones.length - 1].numberPhone)
            setAlarmTelephone(false);
          else setAlarmTelephone(true);
          setTelephone(
            data.customerPhones[data.customerPhones.length - 1].numberPhone
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].zipCode)
            setAlarmCep(false);
          else setAlarmCep(true);
          setCep(
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          ) {
            await findCep(
              data.customerAddresses[data.customerAddresses.length - 1].zipCode,
              true
            );
          }
          if (data.customerAddresses[data.customerAddresses.length - 1].street)
            setAlarmAddress(false);
          else setAlarmAddress(true);
          setAddress(
            data.customerAddresses[data.customerAddresses.length - 1].street
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].number)
            setAlarmNumber(false);
          else setAlarmNumber(true);
          setNumber(
            data.customerAddresses[data.customerAddresses.length - 1].number
          );

          setComplement(
            data.customerAddresses[data.customerAddresses.length - 1].extra
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].district
          )
            setAlarmDistrict(false);
          else setAlarmDistrict(true);
          setDistrict(
            data.customerAddresses[data.customerAddresses.length - 1].district
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].city)
            setAlarmCity(false);
          else setAlarmCity(true);
          setCity(
            data.customerAddresses[data.customerAddresses.length - 1].city
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].state)
            setAlarmState(false);
          else setAlarmState(true);
          setState(
            data.customerAddresses[data.customerAddresses.length - 1].state
          );
        } else {
          clearCustomer();
        }
      })
      .catch((err) => {
        clearCustomer();
        setLoading(false);
        console.log(err);
      });
  }

  async function findCustomer2(documento: string) {
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(documento);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        setLoading(false);
        if (response.data.data.length > 0) {
          const data = response.data.data[0];

          // if(data.customerStatus && data.customerStatus === 'Bloqueado'){
          // 	setDocumentBlocked(data.doc)
          // 	clearAllCustomer();
          // 	Swal.fire({
          // 		icon: "warning",
          // 		title: "Atenção!",
          // 		text: "Conta inativa, entre em contato com a loja",
          // 	});
          // 	return;
          // }

          if (data.name) setAlarmName(false);
          else {
            setAlarmName(true);
          }
          setName(data.name);

          if (data.email) setAlarmEmail(false);
          else setAlarmEmail(true);
          setEmail(data.email);

          if (data.birthDate && data.birthDate != null)
            setAlarmBirthdate(false);
          else setAlarmBirthdate(true);
          setBirthdate(datetimeToDateBR(data.birthDate ? data.birthDate : ""));

          if (data.gender) {
            setGender(data.gender.toLowerCase());
          } else {
            setGender("masculino");
          }

          if (data.inscEstadual) {
            setInscEstadual(data.inscEstadual);
          }

          if (
            data.customerPhones[data.customerPhones.length - 1].numberPhone
              .length >= 11
          ) {
            setMaskTelephone("(99) 99999-9999");
          } else {
            setMaskTelephone("(99) 9999-9999");
          }

          if (data.customerPhones[data.customerPhones.length - 1].numberPhone)
            setAlarmTelephone(false);
          else setAlarmTelephone(true);
          setTelephone(
            data.customerPhones[data.customerPhones.length - 1].numberPhone
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].zipCode)
            setAlarmCep(false);
          else setAlarmCep(true);
          setCep(
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].zipCode
          ) {
            await findCep(
              data.customerAddresses[data.customerAddresses.length - 1].zipCode,
              true
            );
          }
          if (data.customerAddresses[data.customerAddresses.length - 1].street)
            setAlarmAddress(false);
          else setAlarmAddress(true);
          setAddress(
            data.customerAddresses[data.customerAddresses.length - 1].street
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].number)
            setAlarmNumber(false);
          else setAlarmNumber(true);
          setNumber(
            data.customerAddresses[data.customerAddresses.length - 1].number
          );

          setComplement(
            data.customerAddresses[data.customerAddresses.length - 1].extra
          );

          if (
            data.customerAddresses[data.customerAddresses.length - 1].district
          )
            setAlarmDistrict(false);
          else setAlarmDistrict(true);
          setDistrict(
            data.customerAddresses[data.customerAddresses.length - 1].district
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].city)
            setAlarmCity(false);
          else setAlarmCity(true);
          setCity(
            data.customerAddresses[data.customerAddresses.length - 1].city
          );

          if (data.customerAddresses[data.customerAddresses.length - 1].state)
            setAlarmState(false);
          else setAlarmState(true);
          setState(
            data.customerAddresses[data.customerAddresses.length - 1].state
          );
        } else {
          clearCustomer();
        }
      })
      .catch((err) => {
        clearCustomer();
        setLoading(false);
        console.log(err);
      });
  }

  function clearCustomer() {
    setName("");
    setEmail("");
    setBirthdate("");
    setGender("masculino");
    setTelephone("");
    /*
		setCep("");
		setAddress("");
		setNumber("");
		setComplement("");
		setDistrict("");
		setCity("");
		setState("");
		*/
  }

  function clearAllCustomer() {
    setName("");
    setEmail("");
    setBirthdate("");
    setGender("masculino");
    setTelephone("");
    setCep("");
    setAddress("");
    setNumber("");
    setComplement("");
    setDistrict("");
    setCity("");
    setState("");
    setCpfOrCnpj("");
  }

  function createFieldDinamycally(data: configField) {
    switch (data.name) {
      case "nome":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>{data.fieldName}</label>
                <input
                  className={`${alarmName && "alarm-input"}`}
                  type="text"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setName(name.replaceAll("  ", " "));
                    setHideMenu(false);
                    (name === undefined || name === "") && data.mandatory
                      ? setAlarmName(true)
                      : setAlarmName(false);
                  }}
                />
                {alarmName && (
                  <p className="alarm-text">Informe um {data.fieldName}</p>
                )}
              </div>
            )}
          </>
        );
      case "email":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>E-mail</label>
                <input
                  className={`${alarmEmail && "alarm-input"}`}
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    (email === undefined ||
                      email === "" ||
                      !email.includes("@")) &&
                    data.mandatory
                      ? setAlarmEmail(true)
                      : setAlarmEmail(false);
                  }}
                />
                {alarmEmail && (
                  <p className="alarm-text">Informe um e-mail válido</p>
                )}
              </div>
            )}
          </>
        );
      case "dataNascimento":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>Data de Nascimento</label>
                <InputMask
                  className={`${alarmBirthdate && "alarm-input"}`}
                  mask={"99/99/9999"}
                  placeholder="XX/XX/XXXX"
                  type="text"
                  value={birthdate}
                  onChange={(event) => setBirthdate(event.target.value)}
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    (birthdate === undefined ||
                      birthdate === "" ||
                      birthdate[1] === "_") &&
                    data.mandatory
                      ? setAlarmBirthdate(true)
                      : setAlarmBirthdate(false);
                  }}
                />
                {alarmBirthdate && (
                  <p className="alarm-text">Informe uma data de nascimento</p>
                )}
              </div>
            )}
          </>
        );
      case "genero":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>Gênero</label>
                <select
                  onChange={(e) => setGender(e.target.value)}
                  value={gender}
                >
                  <option value="masculino">Masculino</option>
                  <option value="feminino">Feminino</option>
                  <option value="none">Não Informar</option>
                </select>
                {/*<div className='options'>
								<div className="option">
									<input type="radio" checked={gender === 'masculino'} onChange={() => setGender('masculino')} />
									<label>Masculino</label>
								</div>
								<div className="option">
									<input type="radio" checked={gender === 'feminino'} onChange={() => setGender('feminino')} />
									<label>Feminino</label>
								</div>
							</div> */}
              </div>
            )}
          </>
        );
      case "telefone":
        return (
          <>
            {data.visible && (
              <div className="input">
                <label>Telefone do cadastro</label>
                <InputMask
                  className={`${alarmTelephone && "alarm-input"}`}
                  mask={maskTelephone}
                  placeholder="DDD + Telefone"
                  type="text"
                  value={telephone}
                  onBeforeInputCapture={(event) =>
                    changeTelephone(event.currentTarget.value)
                  }
                  onChange={(event) => setTelephone(event.target.value)}
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    telephone[1] === "_" && data.mandatory
                      ? setAlarmTelephone(true)
                      : setAlarmTelephone(false);
                  }}
                />
                {alarmTelephone && (
                  <p className="alarm-text">Informe o telefone</p>
                )}
              </div>
            )}
          </>
        );
    }
  }

  async function saveOrderContext() {
    const orderToStorage = Object.assign(orderContext);
    if (orderToStorage.order !== undefined) {
      await orderContext.encryptOrderStorage(orderToStorage);
    }
  }

  return (
    <div className="customer">
      <div className="content-customer">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: `calc(100vh)` }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="customer-body">
            <h2>Cadastro</h2>
            <div className="group-input">
              {config?.content.pdv.allowSellCnpj && (
                <div className="input">
                  <div className="input-radio">
                    <label className="label-row">
                      <input
                        type="radio"
                        name="radio-doc"
                        value={"cpf"}
                        checked={selectedDoc === "cpf"}
                        onChange={(e) => {
                          setSelectedDoc(e.target.value);
                          setMaskCpfjCnpj("999.999.999-99");
                          setCpfOrCnpj("");
                        }}
                      />
                      <span>CPF</span>
                    </label>
                    <label className="label-row" style={{ marginLeft: 12 }}>
                      <input
                        type="radio"
                        name="radio-doc"
                        value={"cnpj"}
                        checked={selectedDoc === "cnpj"}
                        onChange={(e) => {
                          setSelectedDoc(e.target.value);
                          setMaskCpfjCnpj("99.999.999/9999-99");
                          setCpfOrCnpj("");
                        }}
                      />
                      <span>CNPJ</span>
                    </label>
                  </div>
                </div>
              )}
              <div className="input">
                <label>{selectedDoc === "cpf" ? "CPF" : "CNPJ"}</label>
                <InputMask
                  className={`${alarmCpf && "alarm-input"}`}
                  mask={maskCpfjCnpj}
                  type="text"
                  value={cpfOrCnpj}
                  onChange={(event) => setCpfOrCnpj(event.target.value)}
                  onFocus={() => setHideMenu(true)}
                  onBlur={() => {
                    setHideMenu(false);
                    findCustomer();
                  }}
                />
                {alarmCpf && (
                  <p className="alarm-text">
                    Informe um {selectedDoc === "cpf" ? "CPF" : "CNPJ"} válido
                  </p>
                )}
              </div>
              {selectedDoc === "cnpj" && (
                <div className="input">
                  <label>Inscrição Estadual</label>
                  <input
                    type="text"
                    value={inscEstadual}
                    onChange={(event) => setInscEstadual(event.target.value)}
                    onFocus={() => setHideMenu(true)}
                    onBlur={() => {
                      setHideMenu(false);
                    }}
                  />
                </div>
              )}

              {/* Configurar se tem ou não as configurações de Field */}
              <>
                {!haveFieldConfig ? (
                  <>
                    <div className="input">
                      <label>Nome do Comprador</label>
                      <input
                        className={`${alarmName && "alarm-input"}`}
                        type="text"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        onFocus={() => setHideMenu(true)}
                        onBlur={() => {
                          setName(name.replaceAll("  ", " "));
                          setHideMenu(false);
                          name === undefined || name === ""
                            ? setAlarmName(true)
                            : setAlarmName(false);
                        }}
                      />
                      {alarmName && (
                        <p className="alarm-text">Informe um nome</p>
                      )}
                    </div>
                    <div className="input">
                      <label>E-mail</label>
                      <input
                        className={`${alarmEmail && "alarm-input"}`}
                        type="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        onFocus={() => setHideMenu(true)}
                        onBlur={() => {
                          setHideMenu(false);
                          email === undefined ||
                          email === "" ||
                          !email.includes("@")
                            ? setAlarmEmail(true)
                            : setAlarmEmail(false);
                        }}
                      />
                      {alarmEmail && (
                        <p className="alarm-text">Informe um e-mail válido</p>
                      )}
                    </div>
                    <div className="input">
                      <label>Data de Nascimento</label>
                      <InputMask
                        className={`${alarmBirthdate && "alarm-input"}`}
                        mask={"99/99/9999"}
                        placeholder="XX/XX/XXXX"
                        type="text"
                        value={birthdate}
                        onChange={(event) => setBirthdate(event.target.value)}
                        onFocus={() => setHideMenu(true)}
                        onBlur={() => {
                          setHideMenu(false);
                          birthdate === undefined ||
                          birthdate === "" ||
                          birthdate[1] === "_"
                            ? setAlarmBirthdate(true)
                            : setAlarmBirthdate(false);
                        }}
                      />
                      {alarmBirthdate && (
                        <p className="alarm-text">
                          Informe uma data de nascimento
                        </p>
                      )}
                    </div>
                    <div className="input">
                      <label>Gênero</label>
                      <select
                        onChange={(e) => setGender(e.target.value)}
                        value={gender}
                      >
                        <option value="masculino">Masculino</option>
                        <option value="feminino">Feminino</option>
                        <option value="none">Não Informar</option>
                      </select>
                      {/* <div className='options'>
												<div className="option">
													<input type="radio" checked={gender === 'masculino'} onChange={() => setGender('masculino')}  />
													<label>Masculino</label>
												</div>
												<div className="option">
													<input type="radio" checked={gender === 'feminino'} onChange={() => setGender('feminino')} />
													<label>Feminino</label>
												</div>
												</div> */}
                    </div>
                    <div className="input">
                      <label>Telefone do cadastro</label>
                      <InputMask
                        className={`${alarmTelephone && "alarm-input"}`}
                        mask={maskTelephone}
                        placeholder="DDD + Telefone"
                        type="text"
                        value={telephone}
                        onBeforeInputCapture={(event) =>
                          changeTelephone(event.currentTarget.value)
                        }
                        onChange={(event) => setTelephone(event.target.value)}
                        onFocus={() => setHideMenu(true)}
                        onBlur={() => {
                          setHideMenu(false);
                          telephone[1] === "_"
                            ? setAlarmTelephone(true)
                            : setAlarmTelephone(false);
                        }}
                      />
                      {alarmTelephone && (
                        <p className="alarm-text">Informe o telefone</p>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="input">
                      <label>Nome do Comprador</label>
                      <input
                        className={`${alarmName && "alarm-input"}`}
                        type="text"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        onFocus={() => setHideMenu(true)}
                        onBlur={() => {
                          setName(name.replaceAll("  ", " "));
                          setHideMenu(false);
                          name === undefined || name === ""
                            ? setAlarmName(true)
                            : setAlarmName(false);
                        }}
                      />
                      {alarmName && (
                        <p className="alarm-text">Informe um nome</p>
                      )}
                    </div>
                    {fieldsConfig.map((fieldConfig: configField) =>
                      createFieldDinamycally(fieldConfig)
                    )}
                  </>
                )}
              </>
              <>
                {
                  // Se tipo Food e retirada(withdraw) n é para mostrar os campos de entr
                  typePluginSpace !== "food" && (
                    <>
                      <div className="input">
                        <label>CEP</label>
                        <InputMask
                          className={`${alarmCep && "alarm-input"}`}
                          mask="99999-999"
                          type="text"
                          value={cep}
                          onChange={(event) => setCep(event.target.value)}
                          onFocus={() => setHideMenu(true)}
                          onBlur={(event) => {
                            setHideMenu(false);
                            if (cep[0] === "_") {
                              setAlarmCep(true);
                            } else {
                              findCep(event.target.value);
                              setAlarmCep(false);
                            }
                          }}
                        />
                        {alarmCep && (
                          <p className="alarm-text">Informe o CEP</p>
                        )}
                      </div>
                      <div className="input">
                        <label>Endereço</label>
                        <input
                          className={`${alarmAddress && "alarm-input"}`}
                          type="text"
                          value={address}
                          onChange={(event) => setAddress(event.target.value)}
                          onFocus={() => setHideMenu(true)}
                          onBlur={() => {
                            setHideMenu(false);
                            address === undefined || address === ""
                              ? setAlarmAddress(true)
                              : setAlarmAddress(false);
                          }}
                        />
                        {alarmAddress && (
                          <p className="alarm-text">Informe um endereço</p>
                        )}
                      </div>
                      <div className="input">
                        <label>Número</label>
                        <input
                          className={`${alarmNumber && "alarm-input"}`}
                          type="text"
                          value={number}
                          onChange={(event) =>
                            setNumber(
                              event.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*?)\..*/g, "$1")
                            )
                          }
                          onFocus={() => setHideMenu(true)}
                          onBlur={() => {
                            setHideMenu(false);
                            number === undefined || number === ""
                              ? setAlarmNumber(true)
                              : setAlarmNumber(false);
                          }}
                        />
                        {alarmNumber && (
                          <p className="alarm-text">
                            Informe o número do endereço
                          </p>
                        )}
                      </div>
                      <div className="input">
                        <label>Complemento</label>
                        <input
                          type="text"
                          value={complement}
                          onChange={(event) =>
                            setComplement(event.target.value)
                          }
                          onFocus={() => setHideMenu(true)}
                          onBlur={() => {
                            setHideMenu(false);
                          }}
                        />
                      </div>
                      <div className="input">
                        <label>Bairro</label>
                        <input
                          className={`${alarmDistrict && "alarm-input"}`}
                          type="text"
                          value={district}
                          onChange={(event) => setDistrict(event.target.value)}
                          onFocus={() => setHideMenu(true)}
                          onBlur={() => {
                            setHideMenu(false);
                            district === undefined || district === ""
                              ? setAlarmDistrict(true)
                              : setAlarmDistrict(false);
                          }}
                        />
                        {alarmDistrict && (
                          <p className="alarm-text">Informe um bairro</p>
                        )}
                      </div>
                      <div className="inputs">
                        <div className="input">
                          <label>Cidade</label>
                          <input
                            disabled
                            className={`${
                              alarmCity && "alarm-input"
                            } disabled-input`}
                            type="text"
                            value={city}
                            onChange={(event) => setCity(event.target.value)}
                            onFocus={() => setHideMenu(true)}
                            onBlur={() => {
                              setHideMenu(false);
                              city === undefined || city === ""
                                ? setAlarmCity(true)
                                : setAlarmCity(false);
                            }}
                          />
                          {alarmCity && (
                            <p className="alarm-text">Informe uma cidade</p>
                          )}
                        </div>
                        <div className="input" style={{ width: "20%" }}>
                          <label>Estado</label>
                          <input
                            disabled
                            className={`${
                              alarmState && "alarm-input"
                            } disabled-input`}
                            type="text"
                            value={state}
                            onChange={(event) => setState(event.target.value)}
                            onFocus={() => setHideMenu(true)}
                            onBlur={() => {
                              setHideMenu(false);
                              state === undefined || state === ""
                                ? setAlarmState(true)
                                : setAlarmState(false);
                            }}
                          />
                          {alarmState && (
                            <p className="alarm-text">Informe um estado</p>
                          )}
                        </div>
                      </div>
                    </>
                  )
                }
              </>
            </div>
            {wppAvaiable && (
              <div className="wpp-notification">
                <div className="icon">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 25.8516C0.634451 24.0954 1.19841 22.55 1.76236 21.0045C2.11484 20.2318 2.04433 19.5995 1.62137 18.8268C-2.96078 10.2566 3.24275 -0.0698915 13.0415 0.000356456C19.386 0.000356456 24.8846 4.84747 25.7305 11.1698C26.8584 19.3888 20.0204 26.4838 11.7021 25.6409C10.4332 25.5004 9.09376 25.0086 7.89535 24.5169C7.11991 24.2359 6.48548 24.0954 5.71004 24.3764C4.08867 24.8681 2.4673 25.2896 0.91642 25.7111C0.634442 25.7111 0.422967 25.7111 0 25.8516ZM16.3547 19.8103C17.9056 19.8103 19.0335 19.1078 19.5975 18.1243C20.2319 17.0004 20.0204 16.1574 18.822 15.5252C18.6105 15.3847 18.3286 15.2442 18.0466 15.1739C16.3547 14.3309 16.3547 14.2607 15.2268 15.7359C14.8038 16.2979 14.3809 16.3681 13.8169 16.0169C12.1955 15.1739 10.9266 13.9797 9.93971 12.5045C9.51675 11.8723 9.44623 11.3103 10.0102 10.678C10.4332 10.1863 10.7152 9.62433 10.4332 8.92185C10.0807 8.07887 9.79871 7.2359 9.44624 6.46317C9.23476 5.90119 8.8118 5.69045 8.17735 5.76069C6.69696 5.97144 5.35757 8.14913 5.71004 9.69458C6.69696 13.5582 9.09378 16.3681 12.407 18.4053C13.7464 19.2483 15.0858 19.74 16.3547 19.8103Z"
                      fill="#636363"
                    />
                  </svg>
                </div>
                <div className="info">
                  <p>
                    Aceito ser comunicado via WhatsApp sobre promoções, status
                    de pedidos
                  </p>

                  <div className="options">
                    <div className="option">
                      <input
                        type="radio"
                        name="whatsapp"
                        checked={useWpp === true}
                        onChange={() => setUseWpp(true)}
                      />
                      <label>Aceito</label>
                    </div>
                    <div className="option">
                      <input
                        type="radio"
                        name="whatsapp"
                        checked={useWpp === false}
                        onChange={() => setUseWpp(false)}
                      />
                      <label>Não aceito</label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="button-continue">
              {acceptTerm || !config?.content.pdv.termsActive ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Continuar"
                  onClick={() => {
                    !confirmWpp && useWpp && !customerValidationRegister
                      ? verifyWppToOpen()
                      : continueOrder();
                  }}
                />
              ) : (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Termos de Consentimento"
                  onClick={readTerms}
                />
              )}
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            hide={hideMenu}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {openConfirmWpp && (
          <ModalConfirmWpp
            isOpen={openConfirmWpp}
            setIsOpen={setOpenConfirmWpp}
            code={codeWpp}
            setConfirm={setConfirmWpp}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            customerId={customerId}
            setConfirmValidationRegister={setConfirmValidationRegister}
          />
        )}
        {openTerms && (
          <ModalTerms
            isOpen={openTerms}
            setIsOpen={setOpenTerms}
            termContent={term}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            acceptTerm={acceptTerm}
            setAcceptTerm={setAcceptTerm}
          />
        )}
      </div>
    </div>
  );
}
